import React from 'react';

import { CloseStrongIcon } from 'src/monet/icons';
import { IconButton } from '../../icon-button';

interface Props {
  onClose: () => void;
}

const SlideOverCloseButton = ({ onClose }: Props) => {
  return (
    <IconButton onClick={onClose}>
      <span className='sr-only'>Close panel</span>
      <CloseStrongIcon />
    </IconButton>
  );
};

export default SlideOverCloseButton;
